import React, {useEffect, useState} from "react";
import associateServices from "../../../services";
import Loading from "../../../components/loading";
import {useTranslation} from "react-i18next";
import TableFooter from "../../../components/table-footer/TableFooter";
import NoData from "../../../components/no-data";
import BetsCasino from "./casino-bets-table";
import BetsSportsbook from "./casino-sportsbook-table";
import BetsTrade from "./trade-bets-table";
import {useSelector} from "react-redux";

import SlimSelect from "slim-select";

const TransactionsBets = (props) => {
    const {configuration} = useSelector(state => state.globalReducer)

    const [loading, setLoading] = useState(true)
    const [total, setTotal] = useState(0)
    const [data, setData] = useState([])
    const [page, setPage] = useState(1)
    const [type, setType] = useState('casino')
    const [limit, setLimit] = useState(10)
    const {t} = useTranslation()


    useEffect(() => {
        setLoading(true)

        const getCasinoBets = () => {
            associateServices.getMyDebits({
                type,
                limit,
                page,
            }).then(res => {
                setData(res?.data?.data)
                setTotal(res?.data?.total)
                setLoading(false)
            })
        }
        getCasinoBets()

    }, [page, limit, type])


    const handlePrev = () => setPage(prevState => prevState <= 1 ? 1 : prevState - 1)
    const handleNext = () => setPage(prevState => prevState + 1)

    useEffect(() => {
        new SlimSelect({
            select: '#select-count',
            events: {
                afterChange: newVal => setLimit(newVal[0].value)
            },
            settings: {
                showSearch: false,
            }
        });
    }, [])

    const getDynamicContent = () => {
        if (data?.length <= 0)
            return <NoData desc={t('transactions.bets.empty')}/>


        switch (type) {
            case 'casino':
                return <BetsCasino data={data}/>

            case 'sportsbook':
                return <BetsSportsbook data={data}/>

            case 'trade':
                return <BetsTrade data={data}/>

            default:
                return null
        }

    }
    return (
        <div className="tab-pane fade show active">
            <div className="table-wrap__head">
                <h3 className="settings__title">
                    <span>{t('transactions.bets.title')}</span>

                </h3>

                <select
                    name="lines"
                    id="select-count"
                    disabled={data?.length <= 0}
                    className="table-wrap__select"
                >
                    <option value={'10'}>10</option>
                    <option value={'15'}>15</option>
                    <option value={'20'}>20</option>
                </select>

            </div>


            <div className="table-wrap__head table-wrap__head--content">
                <ul
                    className="nav nav-tabs tabs-nav"
                    id="tabs-nav"
                    role="tablist"
                >
                    <li className="nav-item" role="presentation">
                        <button
                            className={`tabs-nav__btn ${type === 'casino' ? 'active' : ''}`}
                            type="button"
                            onClick={e => setType('casino')}>
                            {t('transactions.bets.table.casino')}
                        </button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button
                            className={`tabs-nav__btn ${type === 'sportsbook' ? 'active' : ''}`}
                            type="button"
                            onClick={e => setType('sportsbook')}
                        >
                            {t('transactions.bets.table.sportsbook')}
                        </button>
                    </li>

                    {
                        configuration?.trade_able ?
                            <li className="nav-item" role="presentation">
                                <button
                                    className={`tabs-nav__btn ${type === 'trade' ? 'active' : ''}`}
                                    type="button"
                                    onClick={e => setType('trade')}
                                >
                                    {t('transactions.bets.table.trade')}
                                </button>
                            </li> : null
                    }

                    {/*<li className="nav-item" role="presentation">*/}
                    {/*    <button*/}
                    {/*        className={`tabs-nav__btn ${type === 'poker' ? 'active' : ''}`}*/}
                    {/*        type="button"*/}
                    {/*        onClick={e => setType('poker')}*/}
                    {/*    >*/}
                    {/*        {t('transactions.bets.table.poker')}*/}
                    {/*    </button>*/}
                    {/*</li>*/}
                </ul>
            </div>


            <div className="tab-content">
                {
                    loading ? <Loading/> :
                        <div className="tab-pane fade show active">
                            <div className="table-responsive">
                                {
                                    getDynamicContent()

                                }
                            </div>
                            {
                                total > 0 &&
                                <TableFooter
                                    total={total}
                                    limit={limit}
                                    handlePrev={handlePrev}
                                    handleNext={handleNext}
                                    section={'debit'}
                                    page={page}
                                    buttonText={t('transactions.bets.table.download')}
                                />
                            }

                        </div>
                }
            </div>
        </div>
    )
}

export default TransactionsBets
